export default __webpack_public_path__ + "static/walter-97ee2d7efa5fd284a745f7d9f633b8cb.png";